import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-card p-3 z-50 md:hidden" data-id="element-105">
      <CTAButton className="w-full text-sm py-3" data-id="element-106">
        SÌ, VOGLIO ACCEDERE ORA (€67)
      </CTAButton>
    </div>;
}